import { useCallback } from "react"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_updatePatientFamilyHistoryInput,
  chUpdatePatientFamilyHistoryMutation,
  chUpdatePatientFamilyHistoryMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdatePatientFamilyHistoryMutation.graphql"
import { chUpdatePatientFamilyHistoryMutation as chMutation } from "@/modules/patients/services/ch/chUpdatePatientFamilyHistory"
import {
  De_updatePatientFamilyHistoryInput,
  deUpdatePatientFamilyHistoryMutation,
  deUpdatePatientFamilyHistoryMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdatePatientFamilyHistoryMutation.graphql"
import { deUpdatePatientFamilyHistoryMutation as deMutation } from "@/modules/patients/services/de/deUpdatePatientFamilyHistory"

const useUpdatePatientFamilyHistoryMutation = (country: Country) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit] = useMutationWithErrorDialog<
    chUpdatePatientFamilyHistoryMutation & deUpdatePatientFamilyHistoryMutation
  >(mutation)

  return useCallback(
    (
      input: De_updatePatientFamilyHistoryInput & Ch_updatePatientFamilyHistoryInput,
      onCompleted?: (
        res: chUpdatePatientFamilyHistoryMutation$data & deUpdatePatientFamilyHistoryMutation$data,
      ) => void,
      onError?: (res: chUpdatePatientFamilyHistoryMutation$data & deUpdatePatientFamilyHistoryMutation$data) => void,
    ) => {
      commit({
        variables: {
          input,
        },
        onCompleted(response) {
          const data = response.updatePatientFamilyHistory
          if (!data.errors?.length) {
            onCompleted?.(response)
          } else {
            onError?.(response)
          }
        },
      })
    },
    [commit],
  )
}

export { useUpdatePatientFamilyHistoryMutation }
